import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "d5b50bf0-75b3-4df8-9d56-df53fc1aca3e",
    content: "Number of sources is irrelevant.",
    options: {},
  },
  {
    id: "e16efc4a-47ee-49ac-af52-04479a1c55c3",
    content: "Specular reflections are included.",
    options: {},
  },
  {
    id: "97995436-e035-47e8-93ea-62a918009e99",
    content: "If the receiver position or orientation changes everything needs to be recalculated.",
    options: {},
  },
  {
    id: "2e351499-611e-43c5-8752-b9638ec1e888",
    content: "Receiver directivity can be included.",
    options: {},
  },
  {
    id: "465a812b-9360-43fb-ac46-8d7b4c443084",
    content: "Scattering effect is included.",
    options: {},
  },
  {
    id: "8a37a6b8-5344-474d-955b-0368d6c03b16",
    content: "Source directivity can be included.",
    options: {},
  },
  {
    id: "4dc14861-5ad4-4318-ba17-8ecc118d7ea1",
    content: "If the source position or orientation changes everything needs to be recalculated.",
    options: {},
  },
  {
    id: "fe71f5db-0e7f-49b0-95d7-df913e486a64",
    content: "Real-time calculation possible.",
    options: {},
  },
];

export const task: Task = {
  id: "e8e18ac1-8621-4c64-8d7e-0b755bd4bfa1",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "d5b50bf0-75b3-4df8-9d56-df53fc1aca3e",
    "e16efc4a-47ee-49ac-af52-04479a1c55c3",
    "2e351499-611e-43c5-8752-b9638ec1e888",
    "465a812b-9360-43fb-ac46-8d7b4c443084",
    "8a37a6b8-5344-474d-955b-0368d6c03b16",
    "4dc14861-5ad4-4318-ba17-8ecc118d7ea1",
    "fe71f5db-0e7f-49b0-95d7-df913e486a64",
  ],
};
